import React, { useState } from 'react'
import img1 from '../../assets/images/pdficon.png'
import img3 from '../../assets/images/downloadicon.png'
import Navbar from '../Navbar'
import Footer from '../footer/Footer'
import { useLocation } from 'react-router-dom'

const InnerMaterial = () => {
    const location = useLocation();
    const { materialdetail } = location.state || {};
    const [confirmpopupOpen, setconfirmPopupOpen] = useState(false);

    const handleconfirmPopupOk = () => {
        setconfirmPopupOpen(false);
    };
    const handleconfirmPopupOpen = () => {
        setconfirmPopupOpen(true);
    };

    const handleconfirmPopupCancel = () => {
        setconfirmPopupOpen(false);
    };

    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                {/* <img src={bannerimg} style={{ width: "100%" }}></img> */}
                <h1 style={{ color: 'white', fontWeight: '600' }}>Material</h1>
            </div>
            <div className='py-5 my-3'>
                <div className='querycard'>
                    {/* <div className='innerhead'>
                        <p className='fw basecolor'>1.Basic Entra Practical Material ....</p>
                    </div> */}
                    <div>
                        <div className="row py-5">
                            {materialdetail.map((item, index) => (
                                <div className="col" key={index}>
                                    <div className="querycarddiv">
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex">
                                                <img src={img1} width={50} alt="Document Icon" />
                                                <p className="fw basecolor" style={{ padding: "10px 40px 0px" }}>
                                                    {item.pdf_name}
                                                </p>
                                            </div>
                                            <div>
                                                <img src={img3} width={50} style={{ cursor: "pointer" }} alt="Download Icon" onClick={handleconfirmPopupOpen} />
                                                {confirmpopupOpen && (
                                                    <div>
                                                        <div
                                                            className="modal-backdrop"
                                                            style={{
                                                                position: "fixed",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                                zIndex: 1040,
                                                            }}
                                                        ></div>
                                                        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header d-flex justify-content-end">
                                                                        <h5 className="modal-title"></h5>
                                                                        <button type="button" className="close" onClick={handleconfirmPopupCancel} aria-label="Close">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body text-center ">
                                                                        Are you want to open the file ?
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-primary loginBtn2" onClick={handleconfirmPopupCancel}>
                                                                            No
                                                                        </button>
                                                                        {/* <button type="button" className="btn btn-primary loginBtn2" onClick={handleconfirmPopupOk}>
                                                                            <a href={item.pdf_url} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none",color:"white"}}>
                                                                                Yes
                                                                            </a>
                                                                        </button> */}
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary loginBtn2"
                                                                            onClick={() => {
                                                                                handleconfirmPopupOk();
                                                                                window.open(item.pdf_url, "_blank", "noopener,noreferrer");
                                                                            }}
                                                                        >
                                                                            Yes
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div>
            <Footer />

        </div>
    )
}

export default InnerMaterial
